import en from "../assets/locale/en.json";
import ja from "../assets/locale/ja.json";
import es from "../assets/locale/es.json";
import fr from "../assets/locale/fr.json";
import ru from "../assets/locale/ru.json";
import zh from "../assets/locale/zh.json";

const LOCALES = { en, ja, es, fr, ru, zh };
const DEFAULT_LOCALE = "en";

const normalizeLocale = (raw) => {
  if (!raw) return DEFAULT_LOCALE;
  const value = String(raw).toLowerCase();
  if (LOCALES[value]) return value;
  const base = value.split(/[-_]/)[0];
  if (LOCALES[base]) return base;
  if (base === "zh" || value.startsWith("zh")) return "zh";
  return DEFAULT_LOCALE;
};

const getCurrentLocale = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return normalizeLocale(urlParams.get("locale"));
};

const pageLocale = (page) => {
  const locale = getCurrentLocale();
  const bundle = LOCALES[locale] || LOCALES[DEFAULT_LOCALE];
  return bundle[page] ?? LOCALES[DEFAULT_LOCALE][page];
};

export { pageLocale, getCurrentLocale };
